/**
 * This is the logo of Podhive <3
 * It is used to display the logo
 * @param width - The width of the logo.
 * @returns The logo of the application.
 */
export function PodhiveLogo({
	width = 250,
	bildmarke = false,
}: {
	width?: number;
	bildmarke?: boolean;
}) {
	return (
		<div className="flex w-fit p-2 flex-col items-center justify-center">
			{bildmarke ? (
				<img
					width={width}
					src="/podhive-wortbildmarke-negativ.png"
					alt="Taxpeer Logo"
				/>
			) : (
				<img width={width} src="/podhive-orange.png" alt="Taxpeer Logo" />
			)}
		</div>
	);
}
